// DS: DS2.7
import React from 'react';
import classnames from 'classnames';
import PlusIcon from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './AddItem.scss';
var AddItem = function (_a) {
    var className = _a.className, onClick = _a.onClick, title = _a.title, disabled = _a.disabled, subtitle = _a.subtitle, biData = _a.biData;
    return (React.createElement(BiButton, { className: classnames(s['root'], className, disabled && s['disabled']), onClick: onClick, biData: biData },
        React.createElement(PlusIcon, { className: s['plus'], size: IconSize.MEDIUM }),
        title && React.createElement("div", { className: s['title'] }, title),
        subtitle && React.createElement("div", { className: s['subtitle'] }, subtitle)));
};
AddItem.displayName = 'AddItem';
export default AddItem;
//# sourceMappingURL=AddItem.js.map